import { QueryClientProvider } from '@tanstack/react-query';
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';

import '@pulse/auth-ui/styles.css';
import './styles/globals.css';
import './styles/pulse.css';

import { App } from './App';
import { AuthProvider } from './auth/auth-provider';
import { createQueryClient } from './lib/query-client';

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('Could not find application root element.');
}

const queryClient = createQueryClient();

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
          <Toaster richColors closeButton position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
